/**
 * 页脚组件
 * 品牌Logo图片 + 版权 + 联系方式
 */
import { Box, Link } from '@mui/material';
import { COLORS } from '@/theme/tokens';
import { COPYRIGHT_TEXT, CONTACT_PHONE, CONTACT_EMAIL } from '@/utils/constants';

/**
 * Footer 组件
 * 固定在页面底部，背景白色，顶部 1px 分割线
 */
export function Footer(): JSX.Element {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: COLORS.backgroundPaper,
        borderTop: `1px solid ${COLORS.border}`,
        py: { xs: 1.5, md: 2 },
        px: { xs: 2, md: 0 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: 1, md: 1.5 },
          flexWrap: 'wrap',
        }}
      >
        {/* 品牌Logo图片 */}
        <Box
          component="img"
          src="/logo.png"
          alt="HyuiCT 虹宇创发"
          sx={{ height: 20, width: 'auto' }}
        />

        {/* 分隔符 */}
        <Box sx={{ color: COLORS.border }}>|</Box>

        {/* 版权 */}
        <Box sx={{ color: COLORS.textDisabled, fontSize: '12px' }}>
          {COPYRIGHT_TEXT}
        </Box>

        {/* 分隔符 */}
        <Box sx={{ color: COLORS.border }}>|</Box>

        {/* 电话 */}
        <Box sx={{ color: COLORS.textDisabled, fontSize: '12px' }}>
          {CONTACT_PHONE}
        </Box>

        {/* 分隔符 */}
        <Box sx={{ color: COLORS.border }}>|</Box>

        {/* 邮箱 */}
        <Link
          href={`mailto:${CONTACT_EMAIL}`}
          sx={{
            color: COLORS.textDisabled,
            fontSize: '12px',
            textDecoration: 'none',
            '&:hover': { color: COLORS.primary },
          }}
        >
          {CONTACT_EMAIL}
        </Link>

      </Box>
    </Box>
  );
}
